// extracted by mini-css-extract-plugin
module.exports = {"copy":"Copy-module--copy--3Yn5E"};